import React, { useEffect, useState } from "react";
import { Button, Table } from "antd";
import { Link } from "react-router-dom";
import { deleteShareClass, getShareClass } from "../../../apis/shareClassApi";

const ShareClass = () => {
  const [shareClass, setShareClass] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchShareClassList();
    setLoading(false);
  }, []);
  const fetchShareClassList = async () => {
    try {
      console.log("first");
      const res = await getShareClass();
      console.log(res, "767676767676767676");
      setShareClass(res?.result || []);
      setLoading(false);
    } catch (e) {
      console.log(e, "error");
    }
  };
  const deleteShareClassRecord = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this ShareClass?"
    );
    if (isConfirmed) {
      console.log(id, "iddddddd");
      const deleteRes = await deleteShareClass(id);
      console.log(deleteRes, "ttttttt");
      setLoading(true);
      fetchShareClassList();
    }
  };
  const columns = [
    {
      title: "S.No",
      dataIndex: "key",
      render: (text, record, index) => <span>{index + 1}</span>,
      width: "10%",
    },
    {
      title: "ShareClass Name",
      //   render: (text, record) => <img src={record.image} />,
      dataIndex: "name",
      width: "20%",
    },
    {
      title: "Type Description",
      dataIndex: "typeDescription",
      width: "30%",
    },

    {
      title: "Years",
      dataIndex: "years",
      width: "10%",
      render: (years) => `${years} Years`,
    },
    {
      title: "Year Description",
      dataIndex: "yearsDescription",
      width: "30%",
    },
    {
      title: "Action",
      className: "text-end",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to={`/AddShareclass/${record.id}`}
              // onClick={() => getShareClass(record.id)}
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            <button
              className="dropdown-item"
              onClick={() => deleteShareClassRecord(record.id)}
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </button>
          </div>
        </div>
      ),
      width: "20%",
    },
  ];
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <Link to="/AddShareclass" className="btn btn-primary mb-3">
              Add ShareClass
            </Link>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={
                    Array.isArray(shareClass) && shareClass.length > 0
                      ? shareClass
                      : []
                  }
                  rowKey="id"
                  //   loading={loading}
                  //   pagination={{ pageSize: 10 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default ShareClass;
